// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"07cf7755","27":"822f8e5a","80":"68596089","198":"963e87e8","364":"0241d2c7","394":"cdd9e59c","467":"fc134539","628":"cad65a23","670":"dca4e14d","795":"360dfeb3"}[chunkId] + ".chunk.css";
};